import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Icon } from '@seeqdev/qomponents';

export type ItemScopeProps = {
  availableOutsideAnalysis: boolean;
  scopeMessage: ScopeMessage;
  canManage: boolean;
  openScopeModal: () => void;
  isLocked?: boolean;
};

export interface ScopeMessage {
  translationString: string;
  translationParameter?: Record<string, string>;
}

export const ItemScope = ({
  availableOutsideAnalysis,
  scopeMessage,
  canManage,
  openScopeModal,
  isLocked = false,
}: ItemScopeProps) => {
  const { t } = useTranslation();

  return (
    <div className="flexRowContainer mb5" data-testid="itemScope">
      <div className="flexColumnContainer flexFill">
        <label className="mb0">{t('PROPERTIES.SCOPE')}</label>
        <a
          href="https://telemetry.seeq.com/support-link/kb/latest/cloud/authorization"
          target="_blank"
          className="ml5"
          rel="noopener">
          <Icon
            icon="fa-question-circle"
            tooltip={t('SCOPE.TOOLTIP')}
            tooltipPlacement="right"
            extraClassNames="text-interactive"
          />
        </a>
      </div>
      <div className="flexColumnContainer mt0 mb0 ml5">
        <span
          className={clsx('specScopeText', {
            'text-italic': availableOutsideAnalysis,
          })}>
          {t(scopeMessage.translationString, { ...scopeMessage.translationParameter })}
        </span>
        {!availableOutsideAnalysis && canManage && !isLocked && (
          <div
            className="specScopeLink ml5 sq-text-primary link-underline-hover cursorPointer"
            data-testid="scopeChange"
            onClick={openScopeModal}>
            {t('SCOPE.CHANGE')}
          </div>
        )}
      </div>
    </div>
  );
};
